export const GRAPHQL_VARIABLES = {
  record: {
    name: '',
    address: {
      address1: '',
      address2: '',
      address3: '',
      state: '',
      city: '',
      zip: '',
      country: '',
      _id: ''
    },
    email: '',
    bookipiCompany: '',
    phoneNumber: '',
    website: '',
    businessType: '',
    businessName: '',
    description: '',
    ABN: '',
    industry: '',
    bankDetails: {
      accountNo: '',
      bsb: ''
    },
    individuals: {
      title: '',
      birth: '',
      firstName: '',
      ownership: '',
      address: {
        address1: '',
        address2: '',
        address3: '',
        state: '',
        city: '',
        zip: '',
        country: '',
        _id: ''
      },
      email: '',
      mobile: '',
      _id: ''
    },
    monthlyCardValue: '',
    monthlyTransactions: '',
    annualTurnover: '',
    serviceDeliveryDays: '',
    fzApplicationId: '',
    fzApplicationStatus: '',
    hasSignature: true,
    verified: true,
    currency: '',
    updatedAt: '',
    createdAt: ''
  }
};

export const QUERY = `
mutation companiesCreateOne ($record: AutoFilledCreateOnecompaniesInput!) {
  companiesCreateOne (record: $record) {
      recordId
      record {
          name
          owner
          address {
              address1
              address2
              address3
              state
              city
              zip
              country
              _id
          }
          email
          bookipiCompany
          phoneNumber
          website
          businessType
          businessName
          description
          ABN
          industry
          personalDetails{
            documentType
            licenceNumber
          }
          bankDetails {
              bankName
              accountName
              accountNo
              routingNumber
          }
          individuals {
              title
              birth
              firstName
              ownership
              address {
                  address1
                  address2
                  address3
                  state
                  city
                  zip
                  country
                  _id
              }
              email
              phone
              _id
          }
          monthlyCardValue
          monthlyTransactions
          annualTurnover
          serviceDeliveryDays
          hasSignature
          verified
          currency
          _id
          updatedAt
          createdAt
          discountedCcRate{ rate fee amexRate amexFee}
          transactions{
                  _id
                  provider
                  type
                  amount
                  status
                  note
                  createdAt
                  ccFee
                }
      }
  }
}
`;
